export default "__VITE_ASSET__Brw_ArQV__"